import { graphql } from "~/gql";

export const LIBRARY_ASSUMPTIONS_QUERY = graphql(/* GraphQL */ `
  query FindLibraryAssumptions($filter: LibraryAssumptionWhereInput!) {
    libraryAssumptions(filter: $filter) {
      ...LibraryAssumptionFragment
    }
  }
`);
